// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  background: #fff;
}

h1 {
  text-align: center;
  margin-top: 20px;
  text-transform: uppercase;
  color: #000;
}

ion-icon {
  filter: invert(1);
}

.info-icon {
  height: 25px;
  width: 25px;
  position: absolute;
  top: 18px;
}

.credit-card-modal {
  position: relative;
  padding: 28px 20px 10px;
  color: #fff;
  font-family: AppFont, sans-serif;
}
.credit-card-modal .close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 20px;
  height: 20px;
  z-index: 2;
}
.credit-card-modal .title {
  margin: 0 0 24px;
  padding-right: 30px;
  text-align: center;
  text-transform: uppercase;
  font-family: AppFontEintrachtOFCSans, AppFontBold, sans-serif;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: 0.02em;
}

.field-block.postal-code-block {
  max-width: 60%;
}

.field-label {
  display: block;
  margin-bottom: 8px;
  font-family: AppFontBold, sans-serif;
  font-weight: 700;
  font-size: 14px;
}

.credit-card-modal ::ng-deep .wpwl-form {
  display: flex !important;
  flex-wrap: wrap !important;
  margin: 0 !important;
  max-width: none !important;
}
.credit-card-modal ::ng-deep .wpwl-group {
  margin: 0 0 20px !important;
  flex: 0 0 100%;
}
.credit-card-modal ::ng-deep .wpwl-group-brand {
  display: none !important;
}
.credit-card-modal ::ng-deep .wpwl-group-cardNumber {
  order: 1;
}
.credit-card-modal ::ng-deep .wpwl-group-cardHolder {
  order: 2;
}
.credit-card-modal ::ng-deep .wpwl-group-expiry {
  order: 3;
  margin-right: 4px !important;
  flex-basis: calc(50% - 4px);
}
.credit-card-modal ::ng-deep .wpwl-group-cvv {
  order: 4;
  margin-left: 4px !important;
  flex-basis: calc(50% - 4px);
}
.credit-card-modal ::ng-deep .wpwl-group-submit {
  order: 5;
}
.credit-card-modal ::ng-deep .wpwl-label {
  display: block;
  margin-bottom: 8px !important;
  padding: 0 !important;
  font-family: AppFontBold, sans-serif !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  color: #000 !important;
}
.credit-card-modal ::ng-deep .wpwl-control {
  width: 100% !important;
  height: 50px !important;
  padding: 0 16px !important;
  border-radius: 10px !important;
  background: transparent !important;
  font-family: AppFont, sans-serif !important;
  font-size: 15px !important;
  box-shadow: none !important;
  border: 1px solid #000 !important;
  color: #000 !important;
}
.credit-card-modal ::ng-deep .wpwl-hint,
.credit-card-modal ::ng-deep .wpwl-icon,
.credit-card-modal ::ng-deep .wpwl-copyright {
  display: none !important;
}
.credit-card-modal ::ng-deep .wpwl-button-pay {
  width: 100% !important;
  height: 54px !important;
  margin-top: 4px !important;
  border: none !important;
  border-radius: 10px !important;
  color: #fff;
  font-weight: 700;
  background: #000 !important;
}

ion-popover {
  --width: 80vw;
}

:host(.dark-menu) .credit-card-modal {
  background: #282828;
}
:host(.dark-menu) .credit-card-modal ::ng-deep .wpwl-button-pay {
  background: var(--ion-color-eintracht-red) !important;
}
:host(.dark-menu) .credit-card-modal ::ng-deep .wpwl-label {
  color: #fff !important;
}
:host(.dark-menu) .credit-card-modal ::ng-deep .wpwl-control {
  color: #fff !important;
  border: 1px solid #4a4a4a !important;
}
:host(.dark-menu) h1 {
  color: #fff !important;
}
:host(.dark-menu) ion-icon {
  filter: none;
}`, "",{"version":3,"sources":["webpack://./src/smoothr-web-app-core/components/credit-card-modal/credit-card-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,gCAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AACJ;AAEE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6DAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAAJ;;AAKE;EACE,cAAA;AAFJ;;AAMA;EACE,cAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AAHF;;AASE;EACE,wBAAA;EACA,0BAAA;EACA,oBAAA;EACA,0BAAA;AANJ;AASE;EACE,2BAAA;EACA,cAAA;AAPJ;AAWE;EACE,wBAAA;AATJ;AAYE;EACE,QAAA;AAVJ;AAaE;EACE,QAAA;AAXJ;AAcE;EACE,QAAA;EACA,4BAAA;EACA,2BAAA;AAZJ;AAeE;EACE,QAAA;EACA,2BAAA;EACA,2BAAA;AAbJ;AAgBE;EACE,QAAA;AAdJ;AAiBE;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;EACA,+CAAA;EACA,2BAAA;EACA,0BAAA;EACA,sBAAA;AAfJ;AAkBE;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BAAA;EACA,kCAAA;EACA,2CAAA;EACA,0BAAA;EACA,2BAAA;EACA,iCAAA;EACA,sBAAA;AAhBJ;AAmBE;;;EAGE,wBAAA;AAjBJ;AAoBE;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AAlBJ;;AAsBA;EACE,aAAA;AAnBF;;AAuBE;EACE,mBAAA;AApBJ;AAwBI;EACE,qDAAA;AAtBN;AA0BI;EACE,sBAAA;AAxBN;AA2BI;EACE,sBAAA;EACA,oCAAA;AAzBN;AA6BE;EACE,sBAAA;AA3BJ;AA8BE;EACE,YAAA;AA5BJ","sourcesContent":[":host {\n  display: block;\n  background: #fff;\n}\n\nh1 {\n  text-align: center;\n  margin-top: 20px;\n  text-transform: uppercase;\n  color: #000;\n}\n\nion-icon {\n  filter: invert(1);\n}\n\n.info-icon {\n  height: 25px;\n  width: 25px;\n  position: absolute;\n  top: 18px;\n}\n\n.credit-card-modal {\n  position: relative;\n  padding: 28px 20px 10px;\n  color: #fff;\n  font-family: AppFont, sans-serif;\n\n  .close-icon {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    width: 20px;\n    height: 20px;\n    z-index: 2;\n  }\n\n  .title {\n    margin: 0 0 24px;\n    padding-right: 30px;\n    text-align: center;\n    text-transform: uppercase;\n    font-family: AppFontEintrachtOFCSans, AppFontBold, sans-serif;\n    font-weight: 700;\n    font-size: 24px;\n    letter-spacing: 0.02em;\n  }\n}\n\n.field-block {\n  &.postal-code-block {\n    max-width: 60%;\n  }\n}\n\n.field-label {\n  display: block;\n  margin-bottom: 8px;\n  font-family: AppFontBold, sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n\n// Skin for the OPPWA/VR-Payment widget markup.\n.credit-card-modal ::ng-deep {\n  .wpwl-form {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    margin: 0 !important;\n    max-width: none !important;\n  }\n\n  .wpwl-group {\n    margin: 0 0 20px !important;\n    flex: 0 0 100%;\n  }\n\n  // Brand is auto-detected (brandDetection: true), no need for the manual selector\n  .wpwl-group-brand {\n    display: none !important;\n  }\n\n  .wpwl-group-cardNumber {\n    order: 1;\n  }\n\n  .wpwl-group-cardHolder {\n    order: 2;\n  }\n\n  .wpwl-group-expiry {\n    order: 3;\n    margin-right: 4px !important;\n    flex-basis: calc(50% - 4px);\n  }\n\n  .wpwl-group-cvv {\n    order: 4;\n    margin-left: 4px !important;\n    flex-basis: calc(50% - 4px);\n  }\n\n  .wpwl-group-submit {\n    order: 5;\n  }\n\n  .wpwl-label {\n    display: block;\n    margin-bottom: 8px !important;\n    padding: 0 !important;\n    font-family: AppFontBold, sans-serif !important;\n    font-weight: 700 !important;\n    font-size: 14px !important;\n    color: #000 !important;\n  }\n\n  .wpwl-control {\n    width: 100% !important;\n    height: 50px !important;\n    padding: 0 16px !important;\n    border-radius: 10px !important;\n    background: transparent !important;\n    font-family: AppFont, sans-serif !important;\n    font-size: 15px !important;\n    box-shadow: none !important;\n    border: 1px solid #000 !important;\n    color: #000 !important;\n  }\n\n  .wpwl-hint,\n  .wpwl-icon,\n  .wpwl-copyright {\n    display: none !important;\n  }\n\n  .wpwl-button-pay {\n    width: 100% !important;\n    height: 54px !important;\n    margin-top: 4px !important;\n    border: none !important;\n    border-radius: 10px !important;\n    color: #fff;\n    font-weight: 700;\n    background: #000 !important;\n  }\n}\n\nion-popover {\n  --width: 80vw;\n}\n\n:host(.dark-menu) {\n  .credit-card-modal {\n    background: #282828;\n  }\n\n  .credit-card-modal ::ng-deep {\n    .wpwl-button-pay {\n      background: var(--ion-color-eintracht-red) !important;\n    }\n\n\n    .wpwl-label {\n      color: #fff !important;\n    }\n\n    .wpwl-control {\n      color: #fff !important;\n      border: 1px solid #4a4a4a !important;\n    }\n  }\n\n  h1 {\n    color: #fff !important;\n  }\n\n  ion-icon {\n    filter: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
